import { computed } from 'vue';
import { useCartorioStore } from '@/stores/cartorio';
import { useRouter } from 'vue-router';

export function usePermissao() {
  const cartorioStore = useCartorioStore();
  const router = useRouter();

  // Computed para verificar se o usuário tem permissão
  const temPermissao = computed(() => {
    if (!cartorioStore.cartorioAtual) {
      return false;
    }
    return cartorioStore.verificarPermissaoFuncao(cartorioStore.funcaoCartorio);
  });

  // Computed para obter informações da função atual
  const funcaoInfo = computed(() => {
    if (!cartorioStore.cartorioAtual) {
      return {
        temCartorio: false,
        funcao: null,
        nomeCartorio: null,
        cns: null
      };
    }
    
    return {
      temCartorio: true,
      funcao: cartorioStore.funcaoCartorio,
      nomeCartorio: cartorioStore.nomeCartorio,
      cns: cartorioStore.cnsAtual
    };
  });

  // Função para verificar permissão e redirecionar se necessário
  const verificarPermissaoERedirecionar = () => {
    if (!temPermissao.value) {
      router.push('/sem-permissao');
      return false;
    }
    return true;
  };

  // Função para obter mensagem de erro personalizada
  const getMensagemErro = () => {
    if (!funcaoInfo.value.temCartorio) {
      return 'Nenhum cartório selecionado. Selecione um cartório válido para continuar.';
    }
    
    return `Usuário sem permissão para utilizar o sistema.`;
  };

  // Helper único para checar permissão e redirecionar se necessário
  const checarPermissaoOuRedirecionar = (funcao) => {
    if (!cartorioStore.verificarPermissaoFuncao(funcao)) {
      sessionStorage.setItem('semPermissaoToast', '1');
      router.push('/sem-permissao');
      return false;
    } else {
      sessionStorage.removeItem('semPermissaoToast');
      return true;
    }
  };

  return {
    temPermissao,
    funcaoInfo,
    verificarPermissaoERedirecionar,
    getMensagemErro,
    checarPermissaoOuRedirecionar
  };
} 